function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import colorVariable from '@mertasan/tailwindcss-variables/colorVariable.js';
export var baseColors = {
    transparent: 'transparent',
    white: '#ffffff',
    black: '#000000',
    neutral: {
        200: '#EAEAEB',
        300: '#D2D3D4',
        500: '#92939A',
        700: '#6C737F',
        900: '#272835',
        1000: '#000000'
    },
    subtle: {
        // aligning from design #FCF7EE and #FFFAF5 (sable clair)
        300: '#FFFAF5',
        // sable fonce
        500: '#F7F0E4',
        700: '#EBE4D5',
        900: '#B1B1B1'
    },
    red: {
        500: '#FF5055',
        700: '#EF6159',
        900: '#E6484D',
        1000: '#A9161A'
    },
    yellow: {
        700: '#FFA500'
    },
    green: {
        700: '#3A8574',
        900: '#2F6C5E'
    },
    blue: {
        300: '#5DB3E6',
        500: '#004E9C'
    },
    orange: {
        50: '#F6F0E4',
        700: '#ED6541',
        900: '#BE5134'
    },
    purple: {
        700: '#431382',
        900: '#3C1175'
    }
};
export var colorValues = _object_spread_props(_object_spread({}, baseColors), {
    fg: {
        base: 'rgba(var(--colors-neutral-900-rgb), var(--tw-text-opacity))',
        inverted: 'rgba(var(--colors-white-rgb), var(--tw-text-opacity))'
    },
    bg: {
        base: 'rgba(var(--colors-subtle-300-rgb), var(--tw-text-opacity))',
        subtle: 'rgba(var(--colors-subtle-500-rgb), var(--tw-text-opacity))'
    },
    link: {
        fg: {
            base: 'rgba(var(--colors-red-500-rgb), var(--tw-text-opacity))'
        }
    },
    tag: {
        bg: {
            base: 'rgba(var(--colors-green-700-rgb), var(--tw-text-opacity))'
        }
    },
    'info-card': {
        accent: 'rgba(var(--colors-orange-700-rgb), var(--tw-text-opacity))'
    },
    'badge-row-card': {
        accent: 'rgba(var(--colors-purple-700-rgb), var(--tw-text-opacity))'
    },
    'badge-list-entry': {
        fg: {
            base: 'rgba(var(--colors-neutral-900-rgb), var(--tw-text-opacity))',
            inverted: 'rgba(var(--colors-white-rgb), var(--tw-text-opacity))'
        }
    },
    'thumbnail-list-entry': {
        accent: 'rgba(var(--colors-green-700-rgb), var(--tw-text-opacity))'
    },
    label: {
        fg: {
            base: 'rgba(var(--colors-neutral-700-rgb), var(--tw-text-opacity))'
        }
    },
    button: {
        main: {
            bg: {
                base: 'rgba(var(--colors-red-500-rgb), var(--tw-text-opacity))',
                hover: 'rgba(var(--colors-red-1000-rgb), var(--tw-text-opacity))'
            },
            fg: {
                base: 'rgba(var(--colors-fg-inverted-rgb), var(--tw-text-opacity))'
            }
        },
        secondary: {
            bg: {
                base: 'rgba(var(--colors-neutral-200-rgb), var(--tw-text-opacity))',
                hover: 'rgba(var(--colors-neutral-300-rgb), var(--tw-text-opacity))'
            },
            fg: {
                base: 'rgba(var(--colors-fg-base-rgb), var(--tw-text-opacity))'
            }
        },
        bordered: {
            border: {
                base: 'rgba(var(--colors-neutral-500-rgb), var(--tw-text-opacity))',
                hover: 'rgba(var(--colors-red-500-rgb), var(--tw-text-opacity))'
            },
            fg: {
                base: 'rgba(var(--colors-fg-base-rgb), var(--tw-text-opacity))'
            }
        },
        ghost: {
            fg: {
                base: 'rgba(var(--colors-fg-base-rgb), var(--tw-text-opacity))',
                hover: 'rgba(var(--colors-red-500-rgb), var(--tw-text-opacity))'
            }
        }
    }
});
export var colors = _object_spread_props(_object_spread({}, colorValues), {
    fg: {
        base: colorVariable('var(--colors-fg-base)'),
        inverted: colorVariable('var(--colors-fg-inverted)')
    },
    bg: {
        base: colorVariable('var(--colors-bg-base)'),
        subtle: colorVariable('var(--colors-bg-subtle)')
    },
    link: {
        fg: {
            base: colorVariable('var(--colors-link-fg-base)')
        }
    },
    tag: {
        bg: {
            base: colorVariable('var(--colors-tag-bg-base)')
        }
    },
    'info-card': {
        accent: colorVariable('var(--colors-info-card-accent)')
    },
    'badge-row-card': {
        accent: colorVariable('var(--colors-badge-row-card-accent)')
    },
    'badge-list-entry': {
        fg: {
            base: colorVariable('var(--colors-badge-list-entry-fg-base)'),
            inverted: colorVariable('var(--colors-badge-list-entry-fg-inverted)')
        }
    },
    'thumbnail-list-entry': {
        accent: colorVariable('var(--colors-thumbnail-list-entry-accent)')
    },
    label: {
        fg: {
            base: colorVariable('var(--colors-label-fg-base)')
        }
    },
    button: {
        main: {
            bg: {
                base: colorVariable('var(--colors-button-main-bg-base)'),
                hover: colorVariable('var(--colors-button-main-bg-hover)')
            },
            fg: {
                base: colorVariable('var(--colors-button-main-fg-base)')
            }
        },
        secondary: {
            bg: {
                base: colorVariable('var(--colors-button-secondary-bg-base)'),
                hover: colorVariable('var(--colors-button-secondary-bg-hover)')
            },
            fg: {
                base: colorVariable('var(--colors-button-secondary-fg-base)')
            }
        },
        bordered: {
            border: {
                base: colorVariable('var(--colors-button-bordered-border-base)'),
                hover: colorVariable('var(--colors-button-bordered-border-hover)')
            },
            fg: {
                base: colorVariable('var(--colors-button-bordered-fg-base)')
            }
        },
        ghost: {
            fg: {
                base: colorVariable('var(--colors-button-ghost-fg-base)'),
                hover: colorVariable('var(--colors-button-ghost-fg-hover)')
            }
        }
    }
});

//# sourceMappingURL=colors.js.map